import { render, staticRenderFns } from "./DeleteIncludeDialog.vue?vue&type=template&id=3b37b8c7&scoped=true"
import script from "./DeleteIncludeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteIncludeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37b8c7",
  null
  
)

export default component.exports